import { MEmailBlock } from '../../mdl/m-template';
import { $el } from '../../ui/elements';
import { $form } from '../../y/form';
import { EDBlockSpec, EDBlock } from '../block';
import { EDBlockContainer } from '../editor';
import { fakeText } from '../elements';
import { EDEmailEditor } from './editor';

export const ed_email_map_block: EDBlockSpec<MEmailBlock, EDEmailEditor> = {
    key: 'map',
    editor_block: class extends EDBlock<EDEmailEditor> {
        constructor(container: EDBlockContainer<EDEmailEditor>) {
            super($form({}), container, 'Map');

            this.ui_add($el.DIV('tl-email-map', [
                $el.DIV('r-image'),
                $el.DIV('r-name', fakeText(12)),
                $el.DIV('r-address', fakeText(20))
            ]));
        }
    },
};
